import { render } from "./AssetsFilterComponent.vue?vue&type=template&id=43037601&scoped=true"
import script from "./AssetsFilterComponent.vue?vue&type=script&lang=js"
export * from "./AssetsFilterComponent.vue?vue&type=script&lang=js"

import "./AssetsFilterComponent.vue?vue&type=style&index=0&id=43037601&lang=scss&scoped=true"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43037601"]])

export default __exports__